import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

var _BlockTypes$TABLE$Blo;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import uuid from 'uuid';
import BlockTypes from '../../../types/BlockTypes';
import parseElementDataset from '../../utils/parseElementDataset';
var newTableIds = {};

function getNewTableId(tableId) {
  if (newTableIds[tableId]) {
    return newTableIds[tableId];
  }

  return newTableIds[tableId] = uuid();
}

export default (_BlockTypes$TABLE$Blo = {}, _defineProperty(_BlockTypes$TABLE$Blo, BlockTypes.TABLE, function (el, next) {
  var _parseElementDataset = parseElementDataset(el.dataset),
      type = _parseElementDataset.type,
      data = _objectWithoutProperties(_parseElementDataset, ["type"]);

  newTableIds = {};
  return {
    object: 'block',
    type: type,
    data: data,
    nodes: next(el.childNodes)
  };
}), _defineProperty(_BlockTypes$TABLE$Blo, BlockTypes.TABLE_CELL, function (el, next) {
  var _parseElementDataset2 = parseElementDataset(el.dataset),
      type = _parseElementDataset2.type,
      data = _objectWithoutProperties(_parseElementDataset2, ["type"]);

  return {
    object: 'block',
    type: type,
    data: _objectSpread({}, data, {
      tableId: getNewTableId(data.tableId)
    }),
    nodes: el.childNodes.length ? next(el.childNodes) : [{
      object: 'text'
    }]
  };
}), _BlockTypes$TABLE$Blo);